import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Portfolio from "./pages/Portfolio";
import Booking from "./pages/Booking";
import MediaManager from "./pages/MediaManager";
import ServiceSocialMedia from "./pages/ServiceSocialMedia";
import ServiceVideoProduction from "./pages/ServiceVideoProduction";
import ServiceContentStrategy from "./pages/ServiceContentStrategy";
import NotFound from "./pages/NotFound";
import Quiz from "./pages/Quiz";
import ExitIntentPopup from "./components/ExitIntentPopup";
import FloatingChatbot from "./components/FloatingChatbot";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <ExitIntentPopup />
      <FloatingChatbot />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/media" element={<MediaManager />} />
          <Route path="/services/social-media" element={<ServiceSocialMedia />} />
          <Route path="/services/video-production" element={<ServiceVideoProduction />} />
          <Route path="/services/content-strategy" element={<ServiceContentStrategy />} />
          <Route path="/quiz" element={<Quiz />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
